class Toggle {
  btn:      Element;
  targets:  NodeListOf<Element>;
  cls:      string;

  constructor(btn: Element, targets: NodeListOf<Element>, cls: string) {
    this.btn     = btn;
    this.targets = targets;
    this.cls     = cls;

    this.init();
  }

  init() {
    this.btn.addEventListener('click', (e) => {
        for (let i = 0; i < this.targets.length; i++) {
            this.targets[i].classList.toggle(this.cls);
        }
    })
  }
}

export { Toggle };
